export default __webpack_public_path__ + "static/media/speed-m.618de18e.svg";